import React from "react";
import { Row, Col, Button, Select, DatePicker, Space } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { SOURCE_TYPES } from "../../utils/constants";
import { getPaymentMethodInFrench, PAYMENT_METHODS } from "../../utils/payment";

const { RangePicker } = DatePicker;
const { Option } = Select;

const TransactionFilterForm = ({
  users,
  zones,
  TypesTransaction,
  setDateRange,
  setSelectedUser,
  setSelectedType,
  setSelectedSource,
  setSelectedPaymentMethod,
  setSelectedZone,
  filterTransactions,
  loading,
}) => (
  <Space direction="vertical" size="middle" className="w-full">
    <Row gutter={16} align="middle">
      <Col xs={24} sm={12} md={6}>
        <RangePicker
          onChange={(dates) => setDateRange(dates)}
          showTime={{ format: "HH:mm" }}
          className="w-full"
        />
      </Col>
      <Col xs={24} sm={12} md={5}>
        <Select
          showSearch
          placeholder="Filtrer par Utilisateur"
          style={{ width: "100%" }}
          onChange={setSelectedUser}
          allowClear
          optionFilterProp="children"
          filterOption={(input, option) =>
            String(option?.children).toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {users.map((user) => (
            <Option key={user.id_agent} value={user.id_agent}>
              {user.full_name}
            </Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} sm={12} md={5}>
        <Select
          mode="multiple"
          placeholder="Filtrer par Type"
          style={{ width: "100%" }}
          onChange={setSelectedType}
          allowClear
        >
          {TypesTransaction.map((type) => (
            <Option key={type} value={type}>
              {type}
            </Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} sm={12} md={4}>
        <Select
          placeholder="Filtrer par Source"
          style={{ width: "100%" }}
          onChange={setSelectedSource}
          allowClear
        >
          {Object.entries(SOURCE_TYPES).map(([key, value]) => (
            <Option key={key} value={key}>
              {value}
            </Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} sm={12} md={4}>
        <Select
          placeholder="Filtrer par Méthode de Paiement"
          style={{ width: "100%" }}
          onChange={setSelectedPaymentMethod}
          allowClear
        >
          {Object.entries(PAYMENT_METHODS).map(([key, value]) => (
            <Option key={key} value={key}>
              {value}
            </Option>
          ))}
    
        </Select>
      </Col>
      <Col xs={24} sm={12} md={4}>
        <Select
          showSearch
          placeholder="Filtrer par Contrat"
          style={{ width: "100%" }}
          onChange={setSelectedZone}
          allowClear
          optionFilterProp="children"
          filterOption={(input, option) =>
            String(option?.children).toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {(zones || []).map((zone) => (
            <Option key={zone.id} value={zone.id}>
              {zone.name}
            </Option>
          ))}
        </Select>
      </Col>
    </Row>
    <Row gutter={16} align="middle">
      <Col xs={24} sm={12} md={4}>
        <Button
          type="primary"
          icon={<FilterOutlined />}
          onClick={filterTransactions}
          loading={loading}
          className="w-full"
        >
          Rechercher
        </Button>
      </Col>
    </Row>
  </Space>
);

export default TransactionFilterForm;
